import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  dataStorageKeywords,
  routeURL,
  userRoles,
} from 'src/utils/properties.utils';
import { getEncryptedLocalStorageData } from 'src/utils/dataStorageManagement.utils';

interface ProtectedRouteProps {
  element: JSX.Element;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ element }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      const isLoggedIn = await getEncryptedLocalStorageData(
        dataStorageKeywords.IS_LOGGED_IN
      );
      if (!isLoggedIn) {
        navigate(routeURL.LOGIN);
        return;
      }
      const highestRole = await getEncryptedLocalStorageData(
        dataStorageKeywords.HIGHEST_ROLE
      );
      if (highestRole !== userRoles.OWNER && highestRole !== userRoles.ADMIN) {
        navigate(routeURL.UNAUTHORIZED_404);
      }
    };

    checkAccess();
  }, [navigate]);

  return element;
};
